<template>
    <div class="d-flex bg-light vh-100"
         :style="{
           backgroundImage: 'url(' + 'forklane-signin-background.jpg' + ')'
             }">
        <div id="layout-center" class="bg-light shadow">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "LayoutCentered"
}
</script>

<style scoped lang="scss">
    #layout-center {
        width: 100%;
        max-width: 420px;
        padding: 1em;
        margin: 200px auto;
    }
</style>